import * as angular from 'angular';

import { IManageUsersSchool, IManageUsersUser } from './../../../../features/manage-users/manage-users.controller';

export interface IModalUserCreateOrUpdate {
  _id?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  googleEmail: string;
  doeEmail: string;
  jobRole: string;
  accessLevel: string;
  isSchoolTrustedUser?: boolean;
}

export type TValidModalUserCreateOrUpdateModes = 'CREATE' | 'UPDATE';

export class ManageUsersCreateOrEditUserModal {
  static $inject: string[] = ['$mdDialog'];

  constructor(private $mdDialog) {
    //
  }

  show(school: IManageUsersSchool, user?: IManageUsersUser, schoolUsers?) {
    const MODE: TValidModalUserCreateOrUpdateModes = user ? 'UPDATE' : 'CREATE';
    const modalUser: IModalUserCreateOrUpdate = this.getModalUser(user);
    const _schoolUsers = schoolUsers || []; // to prevent injection error in ctrl

    const locals = {
      school,
      modalUser,
      schoolUsers: _schoolUsers,
      MODE,
    };

    return this.$mdDialog.show({
      locals,
      disableParentScroll: true,
      template: require('./manage-users-create-or-edit-user-modal.html'),
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      controller: 'ManageUsersCreateNewUserModalCtrl',
      controllerAs: '$ctrl',
    });
  }

  getModalUser(user?: IManageUsersUser): IModalUserCreateOrUpdate {
    let modalUser: IModalUserCreateOrUpdate;

    if (!user) {
      modalUser = {
        firstName: '',
        lastName: '',
        googleEmail: '',
        doeEmail: null,
        jobRole: '',
        accessLevel: '',
      };
    } else {
      const { _id, googleEmail, doeEmail, jobRole, accessLevel, isSchoolTrustedUser } = user;
      const userName = user.name.split(',');
      const firstName = userName[1].trim();
      const lastName = userName[0].trim();

      modalUser = {
        _id,
        firstName,
        lastName,
        googleEmail,
        doeEmail,
        jobRole,
        accessLevel,
        isSchoolTrustedUser,
      };
    }

    return modalUser;
  }
}
